'use strict';

import Events from 'events/events';
import delay from 'helpers/delay';
import DomUtils from 'helpers/dom-utils';
import ElementReplacer from 'helpers/element-replacer';

import closeButtonTemplate from 'components/buttons/button-close/button-close.hbs';
import notificationTemplate from 'components/product/notification/notification.hbs';

function canProvideNotifications() {
  return 'querySelector' in document;
}

if (canProvideNotifications()) {
  init();
}

function init() {
  Events.notificationChangesAvailable.register(addNotification);
  Events.searchDidOpen.register(removeNotification);
  Events.menuWillOpen.register(removeNotification);
  removeNotification();
}

function addNotification(sender, args) {
  const enhancedPathToCheckoutDiv = document.getElementById('enhanced-path-to-checkout-container');

  if (enhancedPathToCheckoutDiv) {
    const { dataset: { enhancedPathToCheckoutEnabled } } = enhancedPathToCheckoutDiv;

    if (enhancedPathToCheckoutEnabled === "true") {
      return;
    }
  }

  if (!args) {
    return;
  }

  let sourceDoc = args.doc;
  let container = sourceDoc.querySelector(args.contentContainer);
  let options = args.options;

  if (!container) {
    return;
  }

  let newNotification = createNotification(container);
  showNotification(newNotification, options);
}

function createNotification(notificationContentContainer) {
  let notification = DomUtils.createElementsFromString(notificationTemplate({notificationContent: ''}))[0];
  let children = notificationContentContainer.childNodes;

  for (let i = 0; i < children.length; i++) {
    let child = children[i];

    if (children[i].nodeType === 3) {
      child = document.createTextNode(child.nodeValue);
    }

    notification.appendChild(child);

  }

  let closeButton = DomUtils.createElementsFromString(closeButtonTemplate({notificationCloseText: 'Close notification'}))[0];
  closeButton.addEventListener('click', removeNotification);
  notification.appendChild(closeButton);

  return notification;
}

function initScrollEventListeners(options){
  let initDelay = (options && options.scrollInitDelay) ? options.scrollInitDelay : 0;
  let scrollTopPositionInital = document.body.scrollTop || document.documentElement.scrollTop;

  const closeNotificationOnScroll = function () {
    let scrollTopPositionScrolling = document.body.scrollTop || document.documentElement.scrollTop;
    let scrollRange = 100;
    if (scrollTopPositionScrolling >= (scrollTopPositionInital + scrollRange) || scrollTopPositionScrolling <= (scrollTopPositionInital - scrollRange)) {
      removeNotification();
      window.removeEventListener('scroll', closeNotificationOnScroll, false);
    }
  }

  delay(initDelay, () => {
    window.addEventListener('scroll', closeNotificationOnScroll, false);
  });
}


function showNotification(newNotification, options) {
  ElementReplacer.insertOrReplaceNode(newNotification, '.notification', ElementReplacer.atEndOf('body'));
  let element = document.querySelector('.notification');

  if (element) {
    DomUtils.addClass(element, 'notification-closed');
    DomUtils.removeClass(element, 'notification-closed');
    delay(10, function () {
      DomUtils.addClass(element, 'notification-opened');
      initScrollEventListeners(options);
    });
  }
}

function removeNotification() {
  let element = document.querySelector('.notification');

  if (element) {
    DomUtils.removeClass(element, 'notification-opened');
    DomUtils.addClass(element, 'notification-closed');
    delay(500, function () {
      DomUtils.addClass(element, 'u-hidden');
      Events.notificationClosed.trigger();
    });
  }
}
